import { BreadcrumbProps } from '../../../types/Breadcrumb';
import { FiChevronRightIcon, FiHomeIcon } from '../../Icon';

import styles from './Breadcrumb.module.scss';

import type { FC, ReactNode } from 'react';

export type Props = {
  breadcrumbElements: BreadcrumbProps[];
};

type BreadProps = BreadcrumbProps & {
  children?: ReactNode;
  length: number;
};

const Bread: FC<BreadProps> = ({ url, order, children, length }) => {
  let cases = 0;
  const firstBread = 1;
  const lastBread = 2;
  if (order === firstBread) {
    cases = firstBread;
  }
  if (length === order) {
    cases = lastBread;
  }
  switch (cases) {
    case firstBread:
      return (
        <a className={styles['link-first']} href={url}>
          <FiHomeIcon size={14} />
          {children}
        </a>
      );
    case lastBread:
      return (
        <span className={styles['link-last']}>
          <FiChevronRightIcon size={14} />
          {children}
        </span>
      );
    default:
      return (
        <a className={styles.link} href={url}>
          <FiChevronRightIcon size={14} />
          {children}
        </a>
      );
  }
};

const BreadList: FC<Props> = ({ breadcrumbElements }) => (
  <>
    {breadcrumbElements.map((breadcrumbProps) => (
      <li className={styles.list} key={breadcrumbProps.order}>
        <Bread
          length={breadcrumbElements.length}
          type={breadcrumbProps.type}
          order={breadcrumbProps.order}
          text={breadcrumbProps.text}
          url={breadcrumbProps.url}
        >
          {breadcrumbProps.text}
        </Bread>
      </li>
    ))}
  </>
);

export const Breadcrumb: FC<Props> = ({ breadcrumbElements }) => (
  <nav className={styles.wrap}>
    <ul className={styles.container}>
      <BreadList breadcrumbElements={breadcrumbElements} />
    </ul>
  </nav>
);
